module.exports = __webpack_public_path__ + "img/download_1.635377f4.svg";